import * as tslib_1 from "tslib";
import { ChangeDetectorRef, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MaintenancesApi } from '@api/maintenances/maintenances.api';
import { ProductServiceValueType } from '@core/interfaces';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { isNil } from 'lodash';
import { debounceTime, first } from 'rxjs/operators';
import { sentry } from 'sentry';
import { AuthenticationService } from '../../../../../../core/authentication/authentication.service';
import english from '../../../../i18n/en.json';
import spanish from '../../../../i18n/es.json';
import portuguese from '../../../../i18n/pt.json';
var TabServicesComponent = /** @class */ (function () {
    function TabServicesComponent(data, progressBar, maintenancesApiService, fuseTranslationLoaderService, changeDetectorRef, authenticationService) {
        this.data = data;
        this.progressBar = progressBar;
        this.maintenancesApiService = maintenancesApiService;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.changeDetectorRef = changeDetectorRef;
        this.authenticationService = authenticationService;
        this.orderBy = 'name_asc';
        this.paymentsFeatureFlag = false;
        this.services = null;
        this.filteredServices = null;
        this.paginationLimit = 0;
        this.paginationOffset = 0;
        this.loadingServices = true;
        this.searchInputValue = new FormControl();
        this.maintenance = this.data.maintenance;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    TabServicesComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.authenticationService.hasFlags('paymentsFeatureFlag')) {
                            this.paymentsFeatureFlag = true;
                        }
                        return [4 /*yield*/, this.loadServices()];
                    case 1:
                        _a.sent();
                        this.searchInputValue
                            .valueChanges
                            .pipe(debounceTime(500))
                            .subscribe(function () {
                            _this.paginationOffset = 0;
                            _this.loadServices();
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    TabServicesComponent.prototype.toNextPage = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.paginationOffset += 5;
                        return [4 /*yield*/, this.loadServices()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TabServicesComponent.prototype.toPreviousPage = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.paginationOffset -= 5;
                        return [4 /*yield*/, this.loadServices()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TabServicesComponent.prototype.orderByName = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.orderBy === 'name_asc') {
                            this.orderBy = 'name_desc';
                        }
                        else {
                            this.orderBy = 'name_asc';
                        }
                        return [4 /*yield*/, this.loadServices()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TabServicesComponent.prototype.showLoading = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var isProgressBarVisible;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loadingServices = true;
                        return [4 /*yield*/, this.progressBar.visible
                                .pipe(first())
                                .toPromise()];
                    case 1:
                        isProgressBarVisible = _a.sent();
                        if (!isProgressBarVisible) {
                            this.progressBar.show();
                            this.changeDetectorRef.markForCheck();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    TabServicesComponent.prototype.hideLoading = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var isProgressBarVisible;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loadingServices = false;
                        return [4 /*yield*/, this.progressBar.visible
                                .pipe(first())
                                .toPromise()];
                    case 1:
                        isProgressBarVisible = _a.sent();
                        if (isProgressBarVisible) {
                            this.progressBar.hide();
                            this.changeDetectorRef.markForCheck();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    TabServicesComponent.prototype.loadServices = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var variables, _a, hasInputValue, _b, _c, err_1, user;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        this.showLoading();
                        if (!isNil(this.data.maintenance.company && this.data.maintenance.company.id)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.hideLoading()];
                    case 1:
                        _d.sent();
                        return [2 /*return*/];
                    case 2:
                        variables = {
                            limit: 5,
                            offset: this.paginationOffset,
                            orderBy: this.orderBy,
                            maintenanceId: this.data.maintenance.id,
                            where: {
                                type: 'service'
                            }
                        };
                        _d.label = 3;
                    case 3:
                        _d.trys.push([3, 8, 9, 10]);
                        _a = this;
                        return [4 /*yield*/, this.maintenancesApiService
                                .searchMaintenanceProductsServices(variables)
                                .toPromise()];
                    case 4:
                        _a.services = _d.sent();
                        if (this.services.totalCount === null) {
                            sentry.captureMessage('Error loading services', {
                                extra: {
                                    variables: JSON.stringify(variables)
                                },
                                user: {
                                    id: this.authenticationService.user.id,
                                    email: this.authenticationService.user.email,
                                    username: this.authenticationService.user.name,
                                }
                            });
                        }
                        hasInputValue = Boolean(this.searchInputValue.value);
                        if (hasInputValue) {
                            variables.where = {
                                name_contains: this.searchInputValue.value
                            };
                        }
                        _b = this;
                        if (!hasInputValue) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.maintenancesApiService.searchMaintenanceProductsServices(variables).toPromise()];
                    case 5:
                        _c = _d.sent();
                        return [3 /*break*/, 7];
                    case 6:
                        _c = this.services;
                        _d.label = 7;
                    case 7:
                        _b.filteredServices = _c;
                        this.paginationLimit = this.filteredServices && this.filteredServices.totalCount <= 5
                            ? this.filteredServices.totalCount
                            : 5;
                        return [3 /*break*/, 10];
                    case 8:
                        err_1 = _d.sent();
                        user = this.authenticationService.user;
                        sentry.captureException(err_1, {
                            extra: {
                                variables: JSON.stringify(variables)
                            },
                            user: {
                                id: user.id,
                                email: user.email,
                                username: user.name,
                            }
                        });
                        return [3 /*break*/, 10];
                    case 9:
                        this.hideLoading();
                        return [7 /*endfinally*/];
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    TabServicesComponent.prototype.convertQuantityByValueType = function (quantity, valueType) {
        switch (valueType) {
            case ProductServiceValueType.hour: {
                return quantity / 60;
            }
            default: {
                return quantity;
            }
        }
    };
    return TabServicesComponent;
}());
export { TabServicesComponent };
